import { Flex } from "@chakra-ui/react";
import { TimelinePlayer } from "components/TimelinePlayer/TimelinePlayer";
import { useForecastTimelineData } from "hooks/useForecastTimelineData";

import { observer } from "mobx-react-lite";
import TimelineForecastSlider from "./TimelineForecastSlider";

export const TimelineForecastContainer = observer(() => {
  const timelineProps = useForecastTimelineData();

  if (!timelineProps?.isVisible) return null;
  if (!timelineProps?.allFrames?.length) return null;

  return (
    <TimelinePlayer {...timelineProps}>
      <Flex align="center" w="100%" pr={4}>
        <TimelineForecastSlider
          totalFrames={timelineProps.totalFrames}
          currentIndex={timelineProps.currentIndex}
          timeMarkers={timelineProps.timeMarkers}
          elapsedTime={timelineProps.elapsedTime}
          onChange={(index: number) => timelineProps.onChangeIndex(index)}
          onClick={timelineProps.productAnalyticsEvent}
        />
      </Flex>
    </TimelinePlayer>
  );
});
